import { Button, Image } from "@jewlr/storybook/core"
import Cookies from "js-cookie"
import PropTypes from "prop-types"
import React, { useState, Suspense } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { flipImage } from "areas/product/store/actions"

const Overlay = styled.div`
  background-color: rgba(100, 100, 100, 0.7);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 49;
`

const Hint = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.grey[35]};
  border-radius: 10px;
  box-shadow: 0 0 5px ${(props) => props.theme.colors.grey[35]};
  display: flex;
  font-size: 13px;
  left: 20px;
  padding: 20px;
  position: absolute;
  top: 0;
  z-index: 50;
  ${(props) => props.theme.mediaQueries.tablet`
    left: 0;
  `}
  :before,
  :after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  :before {
    border-color: rgba(240, 240, 240, 0);
    border-top-color: ${(props) => props.theme.colors.grey[35]};
    border-width: 18px;
    margin-left: -18px;
  }
  :after {
    border-color: rgba(255, 255, 255, 0);
    border-top-color: #fff;
    border-width: 15px;
    margin-left: -15px;
  }
`

const InternalFlipIcon = ({ flip, productType, dataCyType }) => {
  const [showHint, setShowHint] = useState(
    typeof Cookies.get("fliphint") === "undefined"
  )

  const closeHint = (e) => {
    e.stopPropagation()
    Cookies.set("fliphint", true)
    setShowHint(false)
  }

  return (
    <>
      {typeof window !== "undefined" && showHint && (
        <Suspense fallback={<div />}>
          <Hint
            data-cy={`product-flip-hint${dataCyType ? `-${dataCyType}` : ""}`}
          >
            <Button onClick={closeHint} variant="text">
              <Image
                alt="Flip View"
                mr="10px"
                ratio="80 / 70"
                src={require("images/product/icons/flipicon.png")}
                srcSet={`
                ${require("images/product/icons/flipicon.png")} 1x,
                ${require("images/product/icons/flipicon_2x.png")} 2x
              `}
                width="60"
              />
              <span>
                This {productType} has two sides. <br />
                Click to flip and view the other side.
              </span>
            </Button>
          </Hint>
          <Overlay />
        </Suspense>
      )}
      <Button onClick={() => flip()} variant="text">
        <Image
          alt="Flip"
          data-cy={`product-flip-hint-icon${
            dataCyType ? `-${dataCyType}` : ""
          }`}
          ratio="230 / 251"
          src={require("images/icons/flip.svg")}
          width="35"
        />
      </Button>
    </>
  )
}

InternalFlipIcon.propTypes = {
  dataCyType: PropTypes.string,
  flip: PropTypes.func,
  productType: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    productType:
      state.wizard.description.product_type &&
      state.wizard.description.product_type.toLowerCase(),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    flip: () => {
      dispatch(flipImage())
    },
  }
}

const FlipIcon = connect(mapStateToProps, mapDispatchToProps)(InternalFlipIcon)

export default FlipIcon
